var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavenlyDewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 34.6,
    y1: 13.9,
    x2: 50.8,
    y2: 13.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 26.9,
    y1: 20.1,
    x2: 33.7,
    y2: 20.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 20.4,
    y1: 27.4,
    x2: 58.8,
    y2: 27.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 16,
    y1: 33,
    x2: 50.1,
    y2: 33,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 13.4,
    y1: 44.7,
    x2: 50.1,
    y2: 44.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 13.8,
    y1: 61.1,
    x2: 48.8,
    y2: 61.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 23.4,
    y1: 78.4,
    x2: 45.9,
    y2: 78.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 37.3,
    y1: 84.9,
    x2: 47.7,
    y2: 84.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 93.4,
    y1: 50.3,
    x2: 77.2,
    y2: 50.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 101.1,
    y1: 44,
    x2: 94.3,
    y2: 44,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 107.6,
    y1: 87.1,
    x2: 69.2,
    y2: 87.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 112,
    y1: 68.2,
    x2: 77.9,
    y2: 68.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 114.6,
    y1: 72.6,
    x2: 77.9,
    y2: 72.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 114,
    y1: 78.5,
    x2: 79.2,
    y2: 78.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 104.6,
    y1: 84.3,
    x2: 82.1,
    y2: 84.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 90.7,
    y1: 88.8,
    x2: 80.3,
    y2: 88.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 28.4,
    y1: 102.8,
    x2: 28.4,
    y2: 74.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 42.8,
    y1: 42.5,
    x2: 42.8,
    y2: 25.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7dbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0ba4e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#177cc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0666a2"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1)}.c{fill:url(#g2)}.d{fill:url(#g3)}.e{fill:url(#g4)}.f{fill:url(#g5)}.g{fill:url(#g6)}.h{fill:url(#g7)}.i{fill:url(#g8)}.j{fill:url(#g9)}.k{fill:url(#g10)}.l{fill:url(#g11)}.m{fill:url(#g12)}.n{fill:url(#g13)}.o{fill:url(#g14)}.p{fill:url(#g15)}.q{fill:url(#g16)}.r{fill:url(#g17)}.s{fill:url(#g18)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.6 64.2c0 35.1-28.5 63.6-63.6 63.6-35.1 0-63.5-28.5-63.5-63.6 0-35.1 28.4-63.5 63.5-63.5 35.1 0 63.6 28.4 63.6 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m50.8 13.9c0 0-20.4 14-6.7 36.4 0 0-13-8.1-8.6-23.2 0 0 2.3-9.1 15.3-13.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m33.2 20.1c0 0-6.1 12.4 0.5 23.9 0 0-15-11.4-0.5-23.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m21 27.4c0 0 0 14.2 16.6 22.9 16.7 8.8 19.5 17.6 19.5 17.6 0 0 5.1 10.8-2 17.4-1.5 1.4-3.6 2-5.6 1.7-1.6-0.3-3.1-1.1-2.8-3.3 0.6-4.7 7.1-2 7.1-2 0 0 3.2-4-0.3-11.8-3.8-8.5-18.9-15.8-18.9-15.8 0 0-17.6-9.1-13.6-26.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m16.3 33c0 0 1.3 13.8 15.4 23.5 13.6 9.3 18.4 11.4 18.4 11.4 0 0-6.5 2.4-19.8-7.3-13.3-9.7-15.3-21.2-14-27.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m24.8 66.6c-11.4-8-11.4-21.9-11.4-21.9 11.5 26.4 36.7 26.7 36.7 26.7-3.5 1.5-13.9 3.2-25.3-4.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m14 61.1c0 0 13.9 20.2 34.8 14.1 0 0-21.5 13.6-35-13.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m45.9 80.1c0 0-9.3 4.1-22.5-1.7 0 0 15.4 12.1 22.5 1.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m45.1 84.9c0 0 1 2.6 2.6 3.1 0 0-7.4 2.3-10.4-0.9 0 0 6 0.1 7.8-2.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m92.5 27.1c4.4 15.1-8.6 23.2-8.6 23.2 13.7-22.4-6.7-36.4-6.7-36.4 13 4.1 15.3 13.2 15.3 13.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m94.8 20.1c0 0 6.1 12.4-0.5 23.9 0 0 15-11.4 0.5-23.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m93.4 54.1c0 0-15.1 7.3-18.9 15.8-3.5 7.8-0.3 11.8-0.3 11.8 0 0 6.5-2.7 7.1 2 0.3 2.2-1.2 3-2.8 3.3-2 0.3-4.1-0.3-5.6-1.7-7.1-6.6-2-17.4-2-17.4 0 0 2.8-8.8 19.5-17.6 16.6-8.7 16.6-22.9 16.6-22.9 4 17.6-13.6 26.7-13.6 26.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m97.7 60.6c-13.3 9.7-19.8 7.3-19.8 7.3 0 0 4.8-2.5 18.4-11.8 14.1-9.6 15.4-23.1 15.4-23.1 1.3 6.4-0.7 17.9-14 27.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m77.9 71.4c0 0 25.2-0.3 36.7-26.7 0 0 0 13.9-11.4 21.9-11.4 8-21.8 6.3-25.3 4.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m114 61.1c0 0-13.9 20.2-34.8 14.1 0 0 21.9 13.6 34.8-14.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m82.1 80.1c0 0 9.3 4.1 22.5-1.7 0 0-15.4 12.1-22.5 1.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m90.7 87.1c-3 3.2-10.4 0.9-10.4 0.9 1.6-0.5 2.6-3.1 2.6-3.1 1.8 2.3 7.8 2.2 7.8 2.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "r",
    d: "m50.1 101.8c0-10.2 12.4-20.9 13.9-32 1.6 11.1 14 21.8 14 32 0 7-6.3 12.8-14 12.8-7.7 0-13.9-5.8-13.9-12.8zm7.5 5.7c-0.7-0.6-1.7-0.6-2.4 0-0.7 0.6-0.7 1.6 0 2.2 0.7 0.6 1.7 0.6 2.4 0 0.7-0.6 0.7-1.6 0-2.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s",
    d: "m55.7 41.8c0-6.1 7.4-12.4 8.3-19 0.9 6.6 8.3 12.9 8.3 19 0 4.3-3.7 7.7-8.3 7.7-4.6 0-8.3-3.4-8.3-7.7zm4.5 3.4c-0.4-0.3-1-0.3-1.4 0-0.4 0.4-0.4 1 0 1.4 0.4 0.3 1 0.3 1.4 0 0.4-0.4 0.4-1 0-1.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavenlyDewActive);
export default __webpack_public_path__ + "static/media/heavenly-dew-active.132bb76e4087079cddccb1ecef5cc9db.svg";
export { ForwardRef as ReactComponent };